import { createAction } from 'typesafe-actions'
import { SessionActionTypes } from './types'
import { prefix } from '../../config/config'

const actionPrefix = '@@' + prefix + '/'
export const start = createAction(actionPrefix + SessionActionTypes.START)<boolean>()
